const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export function monthLabels(now = new Date()) {
  const m = now.getMonth();
  return {
    thisMonth: MONTHS[m],
    thisMonthOrLater: `${MONTHS[m]} & later`,
    oneMonthAgo: MONTHS[(m + 11) % 12],
    twoMonthsAgo: MONTHS[(m + 10) % 12],
    threeOrMore: `${MONTHS[(m + 9) % 12]} & earlier`,
  };
}

export function buildAgedDebt(customer) {
  const labels = monthLabels();
  const raw = [
    {
      key: "this-month",
      label: labels.thisMonthOrLater,
      amount: (customer?.current ?? 0) + (customer?.dueThisMonth ?? 0),
      color: "bg-green-300",
    },
    {
      key: "1mo",
      label: labels.oneMonthAgo,
      amount: customer?.dueOneMonthAgo ?? 0,
      color: "bg-yellow-300",
    },
    {
      key: "2mo",
      label: labels.twoMonthsAgo,
      amount: customer?.dueTwoMonthsAgo ?? 0,
      color: "bg-orange-300",
    },
    {
      key: "3mo-plus",
      label: labels.threeOrMore,
      amount: customer?.dueThreeOrMoreMonthsAgo ?? 0,
      color: "bg-red-300",
    },
  ];

  const total = raw.reduce((sum, bucket) => sum + (bucket.amount || 0), 0);
  const buckets = raw.map((bucket) => ({
    ...bucket,
    percent: total > 0 ? Math.round((bucket.amount / total) * 100) : 0,
  }));

  const unallocatedCash = customer?.unallocated ?? 0;
  const totalBalance = customer?.balance ?? total + unallocatedCash;

  return { total, buckets, unallocatedCash, totalBalance };
}
